// src/app/meter/components/meter-list/meter-alerts/meter-alerts.component.ts

import { Component, OnInit, OnDestroy } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MeterAbstractService } from '../../../services/meter.abstract.service';
import { AlertItem } from '../../../models/meter-manage.model';

@Component({
    selector: 'app-meter-alerts',
    templateUrl: './meter-alerts.component.html',
    styleUrls: ['./meter-alerts.component.scss'],
})
export class MeterAlertsComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    displayedColumns: string[] = ['nodeId', 'address', 'alertType', 'alertDate', 'notified', 'resolved'];
    alerts: AlertItem[] = [];
    total = 0;
    pageSize = 20;
    pageIndex = 0;
    loading = false;

    showResolved = false;
    selectedAlertTypes: string[] = [];
    alertTypeOptions = ['PROBABLE_LEAK', 'ABNORMAL_RISE', 'DAILY_THRESHOLD', 'PRICE_ALERT'];

    constructor(private meterService: MeterAbstractService) {}

    ngOnInit(): void {
        this.loadAlerts();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onAlertTypeChange(types: string[]): void {
        this.selectedAlertTypes = types;
        this.pageIndex = 0;
        this.loadAlerts();
    }

    onResolvedToggle(): void {
        this.showResolved = !this.showResolved;
        this.pageIndex = 0;
        this.loadAlerts();
    }

    onPageChange(event: PageEvent): void {
        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
        this.loadAlerts();
    }

    formatAddress(item: AlertItem): string {
        return `${item.address.street}, ${item.address.postCode}`;
    }

    private loadAlerts(): void {
        this.loading = true;
        this.meterService
            .getAlerts({
                page: this.pageIndex + 1,
                limit: this.pageSize,
                resolved: this.showResolved ? undefined : false,
                alertType: this.selectedAlertTypes.length > 0 ? this.selectedAlertTypes : undefined,
            })
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (result) => {
                    this.alerts = result.data;
                    this.total = result.total;
                    this.loading = false;
                },
                error: () => {
                    this.loading = false;
                },
            });
    }
}
